import { useEffect, useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBoxProps {
  defaultValue?: string;
  variant?: "navbar" | "page";
  onSearch?: (keyword: string) => void;
  autoFocus?: boolean;
}

export default function SearchBox({
  defaultValue = "",
  variant = "navbar",
  onSearch,
  autoFocus = false,
}: SearchBoxProps) {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState(defaultValue);

  useEffect(() => {
    setKeyword(defaultValue);
  }, [defaultValue]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    if (onSearch) {
      onSearch(value);
      return;
    }
    navigate(`/search?q=${encodeURIComponent(value)}`);
  };

  const isPage = variant === "page";

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={`flex w-full items-center gap-2 rounded-full border border-background-300 bg-background-100 ${
        isPage ? "px-4 py-2" : "px-3 py-1.5"
      }`}
    >
      <span
        className={`flex items-center justify-center text-foreground-500 ${
          isPage ? "h-5 w-5 text-base" : "h-4 w-4 text-sm"
        }`}
      >
        <i className="ri-search-line" />
      </span>
      <input
        type="search"
        name="keyword"
        value={keyword}
        autoFocus={autoFocus}
        onChange={(event) => setKeyword(event.target.value)}
        placeholder="搜索爆料关键词、事件或来源"
        aria-label="搜索新闻"
        className={`min-w-0 flex-1 bg-transparent text-foreground-950 placeholder:text-foreground-500 focus:outline-none ${
          isPage ? "text-sm py-1" : "text-sm"
        }`}
      />
      <button
        type="submit"
        className={`shrink-0 whitespace-nowrap rounded-full bg-primary-500 font-medium text-foreground-950 transition-colors hover:bg-primary-600 ${
          isPage ? "px-4 py-1.5 text-sm" : "px-3 py-1 text-xs"
        }`}
      >
        搜索
      </button>
    </form>
  );
}